import Select from 'react-select';
import { useMemo } from 'react';
import { __ } from '@wordpress/i18n'

export default function UserRolesSelectControl({ value = [], metaKey, updateEditedMeta }) {
    const roles = Array.isArray(value) ? value : [];

    // Flatten grouped role options
    const roleOptions = useMemo(() => {
        return Object.entries(responsive_addons_site_builder.userRoles).map(([groupKey, group]) => ({
            label: group.label,
            options: Object.entries(group.value).map(([val, label]) => ({
                value: val,
                label,
            })),
        }));
    }, []);

    // Selected options based on current meta
    const selectedOptions = useMemo(() => {
        const allOptions = roleOptions.flatMap(group => group.options);
        return roles.map(val => allOptions.find(opt => opt.value === val)).filter(Boolean);
    }, [roles, roleOptions]);

    // Handle role updates
    const handleChange = (selected) => {
        const newRoles = selected.map(opt => opt.value);
        updateEditedMeta(metaKey, newRoles);
    };

    return (
        <div className="responsive-sb-multiselect-wrap">
            <Select
                isMulti
                value={selectedOptions}
                options={roleOptions}
                onChange={handleChange}
                placeholder={__("Select user roles...", "responsive-addons")}
                menuPortalTarget={document.body}
                menuPosition="fixed"
                className="responsive-sb-meta-select responsive-sb-user-roles-select"
                classNamePrefix="responsive"
                styles={{
                    menuPortal: (base) => ({ ...base, zIndex: 999999 }),
                    option: (base, state) => ({
                        ...base,
                        fontSize: '13px',
                        color: '#000',
                        backgroundColor: state.isSelected ? '#007cba' : 'white',
                        ':hover': {
                            backgroundColor: '#f0f0f0',
                        },
                        cursor: 'pointer',
                        paddingLeft: '20px',
                    }),
                    groupHeading: (base) => ({
                        ...base,
                        fontSize: '13px',
                        fontWeight: '600',
                        textTransform: 'capitalize',
                        color: '#000',
                        letterSpacing: '0.5px',
                    }),
                }}
            />

        </div>
    );
}